import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useDocumentTitle from 'hooks/useDocumentTitle';

import { selectMasterBranding, selectMasterCompany } from 'store/auth/selectors';

import { DEFAULT_DOCUMENT_TITLE, DEFAULT_FAVICON_HREF, FAVICON_LINK_SELECTOR } from './constants';

const useBranding = () => {
  const branding = useSelector(selectMasterBranding);
  const company = useSelector(selectMasterCompany);

  const companyName = company?.name ?? null;
  const faviconUrl = branding?.faviconUrl ?? null;

  useDocumentTitle(null, { defaultTitle: companyName || DEFAULT_DOCUMENT_TITLE });

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const faviconLink = document.querySelector(FAVICON_LINK_SELECTOR);

    if (faviconLink) {
      faviconLink.href = faviconUrl || DEFAULT_FAVICON_HREF;
    }
  }, [faviconUrl]);
};

export default useBranding;
